module.exports = __webpack_public_path__ + "public/images/life-skills.3a208365d3fdb5e9a62000cf7784a02e.png";